import React, { Component } from 'react';
import { SearchSchoolBookBtn } from './SearchSchoolBookBtn';
import PropTypes from 'prop-types';
import { getTimeLabel, getTrainingDateRangeLabel } from './SearchSchool.functions';
import { events } from '../../util/Events';
import { CART_EVENT_UPDATED, inSchoolCartService } from './InSchoolCart/InSchoolCart.service';

const CartService = inSchoolCartService;

export class SearchSchoolResultItem extends Component {

  constructor(props) {
    super(props);

    this.state = {
      status: 'book',
    };

    // bind event
    events.on(CART_EVENT_UPDATED, () => this._checkCartStatus());
  }

  componentDidMount() {
    this._checkCartStatus();
  }

  /**
     * After removing items from the cart we need to
     * recheck all buttons to check whether the trainings are
     * in the cart
     * @private
     */
  _checkCartStatus() {
    const inCart = this._trainingIsInCart();
    this.setState({
      status: inCart ? 'cart' : 'book',
    });
  }


  /**
     * Checks if the training has been added to the shopping cart
     * @returns {boolean}
     * @private
     */
  _trainingIsInCart() {
    const cartList = CartService.get();
    const trainingId = this.props.training.id_training;

    if (cartList) {
      return cartList.includes(trainingId);
    }

    return false;
  }

  render() {
    const { status } = this.state;

    const { training, post } = this.props;

    const showTrainingNotice = post.training_notice.show.includes('true');

    const timeLabel = getTimeLabel(
      training.general_start_time,
      training.general_end_time
    );

    const dateLabel = getTrainingDateRangeLabel(
      training.datum_start,
      training.datum_eind
    );

    const urgencyNotification = (
      <span className="school-page__item-urgent-note">
        <span className="school-page__item-urgent-note-text">
          {post.training_notice.notice}
        </span>
        { post.training_notice.tooltip
                && <i className="fa fa-info-circle bem-info-icon">
                  <span className="js-tooltip bem-tooltip school-page__item-urgent-tooltip animated fadeInUp">
                    {post.training_notice.tooltip}
                  </span>
                </i> }
      </span>
    );

    let itemClass = 'school-page__training';
    if (showTrainingNotice) {
      itemClass += ' school-page__training--urgent';
    }


    // this will force re-rendering the child component when the state change
    const bookBtn = [training].map((training, key) => (
      <SearchSchoolBookBtn
        key={key + status}
        training={training}
        status={status}/>
    ));

    return (
      <div className={itemClass} data-item={training.id_training}>
        <div className="school-page__training-content">
          <span className="school-page__training-label">{training.product_naam}</span>
          <div className="school-page__training-info">
            <span>{training.vak_naam} {training.vak_niveau} |</span> <span>{dateLabel} |</span> <span>{timeLabel}</span>
            {showTrainingNotice && status === 'book' && urgencyNotification}
          </div>
          <div className="school-page__training-location">
            <span>{training.loc_naam},</span> <span>{training.loc_straat} {training.loc_nr}</span>
          </div>

        </div>
        <div className="school-page__training-price">
                    &euro; {training.prijs}
        </div>
        {bookBtn}
      </div>
    );
  }
}

SearchSchoolResultItem.propTypes = {
  training: PropTypes.object,
  post: PropTypes.object,
};
